import React, { Component } from 'react'
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Card,Header, Segment, Tab  } from 'semantic-ui-react';

import UserContext from '../contexts/UserContext';
import Calendar from './Calendar/Calendar';
import OutstandingTickets from './OustandingRequests/OustandingTickets';
import PortalUpdates from './PortalUpdates/PortalUpdates';

export default class Dashboard extends Component {
    static contextType = UserContext

    getWeek = () => {
        Date.prototype.getWeek = function () {
            var target  = new Date(this.valueOf());
            var dayNr   = (this.getDay() + 6) % 7;
            target.setDate(target.getDate() - dayNr + 3);
            var firstThursday = target.valueOf();
            target.setMonth(0, 1);
            if (target.getDay() !== 4) {
                target.setMonth(0, 1 + ((4 - target.getDay()) + 7) % 7);
            }
            return 1 + Math.ceil((firstThursday - target) / 604800000);
        }
        var d = new Date();
        return d.getWeek()
    }

    render() {
        if(this.context.userInfo !== null){
            const sprintNumber = this.getWeek()
            const currentDay = new Date().getDay()
            const panes = [
                { menuItem: 'Outstanding Requests', render: () => <Tab.Pane><OutstandingTickets /></Tab.Pane>},
                { menuItem: 'Calendar', render: () => <Tab.Pane><Calendar /></Tab.Pane> },
                // { menuItem: 'Map', render: () => <Tab.Pane><MainPage/></Tab.Pane> },
                
            ]
        return (
            <>
            <Helmet>
                <title>Dashboard</title>
            </Helmet>
                {localStorage.getItem('admin-storage') && localStorage.getItem('admin-storage') !== "false"?
                <Segment className='dashboard-header-container'padded="very">
                    <Header className="header-text-container">
                        <Header.Content>
                            <h1>Welcome to the GridSec side of the Portal</h1>
                            <h4>Sprint Week: {sprintNumber}.{currentDay}</h4>
                        </Header.Content>
                    </Header>
                    <div className='username-banner'>{this.context.userInfo.username}</div>
                </Segment> :
                <Segment className='header-container'padded="very">
                    <Header className="dashboard-header">
                        <Header.Content>
                            <h1>Welcome to the GridSec Customer Portal</h1>
                        </Header.Content>
                    </Header>
                    <div>{this.context.userInfo.username}</div>
                </Segment>
                }
                
                <Segment basic>
                {localStorage.getItem('admin-storage') && localStorage.getItem('admin-storage') !== "false"?<PortalUpdates/>:null}
                <Card.Group>
                        <Card as={Link} to ="/tickets/incident"className='card-body'>
                            <Card.Content>
                                <Card.Header>Submit Incident Request</Card.Header>
                                    <Card.Description>Submit an Incident Request</Card.Description>
                            </Card.Content>
                        </Card>
                        <Card as={Link} to ="/tickets/access"className='card-body'>
                            <Card.Content>
                                <Card.Header>Submit Access Request</Card.Header>
                                    <Card.Description>Submit an Access Request</Card.Description>
                            </Card.Content>
                        </Card>
                        <Card as={Link} to="/tickets/tca" className='card-body'>
                            <Card.Content>
                                <Card.Header>TCA/RM Request</Card.Header>
                                    <Card.Description>Submit TCA/RM Requests</Card.Description>
                            </Card.Content>
                        </Card>
                        <Card as={Link} to="/tickets/change" className='card-body'>
                            <Card.Content>
                                <Card.Header>Submit a Change Request</Card.Header>
                                    <Card.Description>Submit a Change Request</Card.Description>
                            </Card.Content>
                        </Card>
                        {localStorage.getItem('admin-storage') && localStorage.getItem('admin-storage') !== "false"?
                            null 
                        :
                            <Card as={Link} to="/reports" className='card-body'>
                                <Card.Content>
                                    <Card.Header>Reports</Card.Header>
                                        <Card.Description>View monthly security reports</Card.Description>
                                </Card.Content>
                            </Card>
                        }
                    {localStorage.getItem('admin-storage') && localStorage.getItem('admin-storage') !== "false"?
                    <Card as={Link} to="/admin/tickets" className='card-body'>
                        <Card.Content>
                            <Card.Header>Support Tickets</Card.Header>
                                <Card.Description>View and Submit Support Tickets</Card.Description>
                        </Card.Content>
                    </Card>
                    :
                    <Card as={Link} to="/tickets" className='card-body'>
                        <Card.Content>
                            <Card.Header>Tickets</Card.Header>
                                <Card.Description>View and Submit Tickets</Card.Description>
                        </Card.Content>
                    </Card>
                    }
                    </Card.Group>
                </Segment>
                <Segment>
                    <Tab panes={panes}/>
                </Segment>
            </>
        )}
        else{return <div></div>}
    }
}
